export interface CCTConfigs {
  TIME_THRESHOLD: number;
  TIME_THRESHOLD_SUBSEQUENT: number;
  MAXMIUM_ACCOUNTS: number;
  ACTIVE_SESSION_EVALUATE_INTERVAL: number;
  INTERACTION_REFRESH_LINK_LOGS_TIME: number;
  APP_IDLE_TIME: number;
  APP_TIMEOUT: number;
  APP_SESSION_TIMEOUT: number;
  GENSYS_IDLE_TIME:number;
  OUTBOUND_POPUP_TIME:number;
  MAX_MULTIPLE_ACCOUNTS:number;
  RETRY_ATTEMPTS:number;
  IDV_POLL_DURATION: number;
  MAX_IDV_POLL_DURATION: number;
  BIOMETRIC_POLL_API_INTERVAL: number;
  MAX_BIOMETRIC_POLL_DURATION: number;
}

export class awsConfig {
  accessKeyId: string = '';
  secretAccessKey: string = '';
  region: string = '';
}
